export enum ListViewFilterTagType {
  Count,
  DropdownWithoutTotalCount,
  Input,
  Date,
  DateRange,
  Binary
}
